<template>
  <div class="container">
    <van-overlay :show="showOverlay" @click="onClickHide" z-index="3">
      <div class="overlay-wrapper">
        <div>
          点击页面右上角分享集赞<img class="arrow" src="../../assets/images/extra-style/arrow.png"><br>或长按页面保存图片到本地
        </div>
      </div>
    </van-overlay>
    <SuppportPoster></SuppportPoster>
  </div>
</template>
<script>
import SuppportPoster from './support-poster'
import { commonUtils } from '../../utils/common'
import { userUtils } from '../../utils/auth'
export default {
  name: 'thanksLetterPoster',
  components: {
    SuppportPoster
  },
  data () {
    return {
      showOverlay: true
    }
  },
  mounted () {
    this.clientInfo = userUtils.getClientInfo()
    // console.log(this.clientInfo)
    console.log('reload')
    if (location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
    this.initWxJsSdk()
  },
  methods: {
    onClickHide () {
      this.showOverlay = false
    },

    // 初始化微信jssdk
    initWxJsSdk () {
      let sdkUrl = null
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        sdkUrl = global.entryUrl
      }
      let clientName = this.clientInfo.clientName
      let clientId = this.clientInfo.clientId
      const url = `${document.location.origin}/v2/activity/support-poster?clientId=${clientId}&clientName=${clientName}`
      console.log(url)
      const appMessageShare = {
        title: '请收下我的新年祝福', // 分享标题
        desc: '打开祝福为我点赞吧！', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/extra-logo.png', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }

      const timelineShare = {
        title: '请收下我的新年祝福', // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/extra-logo.png', // 分享图标
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils.configWxJsSdk(appMessageShare, timelineShare, sdkUrl).then(() => {
        this.wxReady = true
      }).catch(error => {
        console.log('poster error', error)
        this.$emit('error', { errorMsg: error })
      })
    }
  }
}
</script>
<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  .overlay-wrapper {
    // display: flex;
    // align-items: center;no-repeat
    // justify-content: center;
    height: 100%;
    line-height: 40px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    z-index: 3;
    .arrow {
      padding-left: 10px;
      width: 80px;
    }
  }
}
</style>
